/* eslint-disable */

const unhideEls = (list, limit) => {
    for (let i = 0; i < Math.min(list.length, limit); i++) {
        list[i].hidden = false;
    }
}

const loadMore = (selector, limit, loadMoreButtonSelector) => {

    document.querySelector(loadMoreButtonSelector).addEventListener('click', (e) => {
        if (document.querySelectorAll(selector).length > 0) {
            let hiddenEls = document.querySelectorAll(selector);
            unhideEls(hiddenEls, limit);
            hiddenEls[0].focus();

            if (document.querySelectorAll(selector).length < 1) {
                document.querySelector(loadMoreButtonSelector).hidden = true;
            }
            else {
                document.querySelector(loadMoreButtonSelector).hidden = false;
            }
        }
    });
    if (document.querySelectorAll(selector).length > 0) {
        document.querySelector(loadMoreButtonSelector).hidden = false;
    }
    else {
        document.querySelector(loadMoreButtonSelector).hidden = true;
    }
}

export {
    unhideEls,
    loadMore,
}
